import { createSlice } from "@reduxjs/toolkit";
import { getVisionMissionList, saveVisionMission, deleteVisionMission } from "../controller/visionMission.controller";
import { VisionMission } from "../types/visionMissionType";
import { SaveResponse } from "../types/common";

interface VisionMissionState {
  loading: boolean;
  list: VisionMission[];
  total: { pages: number; data: number };
  response: SaveResponse | null;
  error: string | null;
}

const initialState: VisionMissionState = {
  loading: false,
  list: [],
  total: { pages: 0, data: 0 },
  response: null,
  error: null,
};

const visionMissionSlice = createSlice({
  name: "visionMission",
  initialState,
  reducers: {
    resetVisionMissionResponse: (state) => {
      state.response = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVisionMissionList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVisionMissionList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data?.data ?? [];
        state.total = action.payload.data?.total ?? { pages: 0, data: 0 };
      })
      .addCase(getVisionMissionList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal memuat data visi & misi";
      })
      .addCase(saveVisionMission.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveVisionMission.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload;
      })
      .addCase(saveVisionMission.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal menyimpan visi & misi";
      })
      .addCase(deleteVisionMission.fulfilled, (state, action) => {
        state.response = action.payload;
      });
  },
});

export const { resetVisionMissionResponse } = visionMissionSlice.actions;
export default visionMissionSlice.reducer;
